var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberList1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,0 C10.522125,0 0,10.522125 0,23.5 C0,36.477875 10.522125,47 23.5,47 C36.477875,47 47,36.477875 47,23.5 C47,10.522125 36.477875,0 23.5,0 Z",
    id: "Shape-Copy-4",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 30,
    fontWeight: "bold",
    fill: "#FAFAFA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14,
    y: 34
  }, "1")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberList1);
export default __webpack_public_path__ + "static/media/Number List 1.801820c8.svg";
export { ForwardRef as ReactComponent };